import { useState, useRef } from 'react';
import Imatge from 'components/3catinfo/Imatge';
import Player from 'components/3catinfo/Player';
import Boto from 'components/3catinfo/Boto/Boto';
import LoadingPlayer from 'components/3catinfo/Players/LoadingPlayer';
import clsx from 'clsx';
import styles from './playerdestacat.module.scss';

const PlayerDestacat = (props) => {
    const { id, imatges, className, priorityImage, numColumnsRow, estil, testId } = props;
    const uniquePlayerId = useRef(Date.now()).current;
    const playerVideoTagId = `player-destacat-${id}`;
    const [playerVisible, setPlayerVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const playerRef = useRef();
    const contentPlayerRef = useRef();

    const playerControllerInstance = (playerController) => {
        playerController.on('loadedmetadata', () => {
            setIsLoading(false);
            if (contentPlayerRef?.current?.querySelector('.bmpui-ui-playbacktogglebutton'))
                contentPlayerRef.current.querySelector('.bmpui-ui-hugeplaybacktogglebutton').focus();
        });
    };

    const stylesContentPlayerDestacat = clsx(styles.contentPlayerDestacat, estil && styles[estil], className);

    const stylesPlayerDestacat = clsx({
        [styles.mediaVideo]: true,
        [styles.hidden]: !playerVisible || isLoading
    });

    return (
        <div className={stylesContentPlayerDestacat} data-testid={testId}>
            {!playerVisible ? (
                <div
                    className={styles.contentBoto}
                    onClick={() => {
                        setPlayerVisible(true);
                        playerRef?.current?.play();
                    }}
                >
                    <div className={styles.imatgeWrapper}>
                        <Imatge
                            imatges={imatges}
                            className={styles.imatge}
                            tipus='web_destacat'
                            numColumnsRow={numColumnsRow}
                            aria-hidden='true'
                            layout='fill'
                            objectFit='cover'
                            priority={priorityImage}
                            crop='1903'
                            data_testid='destacat-img'
                        />
                    </div>
                    <div className={styles.icona_play}>
                        <Boto
                            className={styles.play}
                            tag='button'
                            icona='play'
                            isIconaBlanc={true}
                            estil='noEstil'
                            alt='reproduir'
                            ariaLabelBtn='Reprodueix'
                        />
                    </div>
                </div>
            ) : (
                <>
                    {isLoading && (
                        <LoadingPlayer className={styles.loading} text='Carregant vídeo' numColumnsRow={numColumnsRow} />
                    )}
                    <div className={stylesPlayerDestacat} ref={contentPlayerRef}>
                        <Player
                            ref={playerRef}
                            id={id}
                            estils='noticia'
                            playerVideoTagId={`id-${uniquePlayerId}-${playerVideoTagId}`}
                            autoPlay={true}
                            playerControllerInstance={playerControllerInstance}
                            mostrarBotonsAccessibilitat={false}
                            eliminarPrimerTabIndex={true}
                        />
                    </div>
                </>
            )}
        </div>
    );
};

export default PlayerDestacat;
